<template>
  <div class="complispace-student-management-config">
    <v-row no-gutters>
      <div v-for="(file, fileIndex) in files" :key="fileIndex">
        <div v-if="!file.isDeleted">
          <v-col cols="12" class="pa-0">
            <label :for="getUploadFileId(fileIndex)">
              <input
                :id="getUploadFileId(fileIndex)"
                style="display: none"
                type="file"
                :accept="fileExtensions"
                :disabled="serviceEnded"
                @change="onFileChange($event, file, fileIndex)"
              />
            </label>
            <cs-button
              :id="getUploadFileBtnId(fileIndex)"
              primary
              class="excursion-stepper-upload-btn ma-0"
              left-icon="mdi-upload"
              label="Upload Subjects CSV"
              :disabled="serviceEnded"
              @click="uploadFileClick(fileIndex)"
            ></cs-button>
          </v-col>
          <v-col cols="12" class="px-0">
            <span class="form-label template-file-font ma-0">File Name</span>
          </v-col>
          <v-col cols="12" class="pa-0">
            {{ file.filename }}
          </v-col>
        </div>
      </div>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ComplispaceStudentManagementConfig',

  props: {
    files: {
      type: Array,
      default: () => [{}]
    },
    serviceEnded: {
      type: Boolean,
      default: false
    },
    fileExtensions: {
      type: String,
      default: '.csv'
    }
  },

  emits: ['file-changed'],

  methods: {
    getUploadFileId(index) {
      return `uploadFile__studentManagement__${index}`;
    },
    getUploadFileBtnId(index) {
      return `uploadFileBtn__studentManagement__${index}`;
    },
    uploadFileClick(index) {
      document.getElementById(this.getUploadFileId(index)).click();
    },
    onFileChange(event, file, index) {
      this.$emit('file-changed', { event, file, index });
    }
  }
};
</script>
